import { Errors } from './Errors'

export class Form {


    /**
     * Create a new Form instance.
     *
     * @param {object} data
     */
    constructor(data) {
        this.originalData = data;

        for (let field in data) {
            this[field] = data[field];
        }

        this.errors = new Errors();
        this.busy = false;
    }


    /**
     * Fetch all relevant data for the form.
     */
    data() {
        let data = {};

        for (let property in this.originalData) {
            data[property] = this[property];
        }

        return data;
    }


    /**
     * Reset the form fields.
     */
    reset() {
        for (let field in this.originalData) {
            this[field] = '';
        }

        this.errors.clear();
    }


    /**
     * Submit the form.
     *
     * @param {function} request
     */
    submit(request) {
        return request().then(response => {
            this.onSuccess(response.data);
        })
            .catch(error => {
                this.onFail(error.response.data);
            });

    }

    /**
     * Record generic form errors and errors only for available fields.
     *
     * @param errors
     */
    recordErrors(errors) {
        let e = {};

        //Record form wide error
        if (errors.hasOwnProperty('error') && errors.hasOwnProperty('message')) {
            e['form'] = [errors['message']]
        }

        // Record errors for available fields only
        for (let field in errors) {
            if (!errors.hasOwnProperty(field)) continue;

            if (this.originalData.hasOwnProperty(field)) {
                e[field] = errors[field];
            }
        }

        this.errors.record(e);
    }


    /**
     * Handle a successful form submission.
     *
     * @param {object} data
     */
    onSuccess(data) {
        this.reset();
    }


    /**
     * Handle a failed form submission.
     *
     * @param {object} errors
     */
    onFail(errors) {
        this.recordErrors(errors);
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/modules/forms/Form.js